export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10318.f3a6ae71.jpg";